/* global document:readonly */
function _load(tag) {
    /**
   * Load JS, CSS or IMG
   *
   * @param url {string} url of resource to load
   * @param opts {object} options
   * @param opts.insertBefore {boolean} insert CSS before other CSS
   * @return {Promise<url>}
   */
    return (url, opts) => {
        // eslint-disable-next-line no-param-reassign
        opts = opts || {};
        // This promise will be used by Promise.all to determine success or failure
        return new Promise((resolve, reject) => {
            const element = document.createElement(tag);
            const parent = document.head;
            let beforeDom = null;
            let attr = 'src';
            element.setAttribute('data-injected', true);

            // Important success and error for the promise
            element.onload = () => {
                resolve(url);
            };
            element.onerror = () => {
                reject(url);
            };

            // Need to set different attributes depending on tag type
            switch (tag) {
                case 'script':
                    element.async = true;
                    break;
                case 'link':
                    element.type = 'text/css';
                    element.rel = 'stylesheet';
                    attr = 'href';
                    if (opts.insertBefore) {
                        // insert before first stylesheet but after other injected links
                        beforeDom = document.querySelector('link[rel="stylesheet"]:not([data-injected])');
                    }
                    break;
                default: // no-op
            }

            // Inject into document to kick off loading
            element[attr] = url;
            parent.insertBefore(element, beforeDom);
        });
    };
}

export default {
    css: _load('link'),
    js: _load('script'),
    img: _load('img')
};
